import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import Layout from '../Cliente/Layout/Layout';
import TitleSection from '../../components/TitleSection/TitleSection';
import { getContrato, getUser } from '../../services/Storage.Utils';
import { FacturasEnabled } from '../../../config';
import DocumentosContrato from './DocumentosContrato';
import './Documentos.scss';

/**
 * Documentos descargables del titular: boletas de sus pagos de mantención y
 * facturas, agrupadas por contrato. Mismo layout colapsable que "Aceptar y
 * pagar pie Contrato".
 */
const Documentos = () => {
  const Agreement = getContrato();
  const contratos =
    Agreement && Agreement !== null
      ? Object.keys(Agreement).map((i) => Agreement[i])
      : [];
  const [collapse, setCollapse] = useState(1);

  const toggle = (e, tab) => {
    e.preventDefault();
    setCollapse(collapse === tab ? 0 : tab);
  };

  return (
    <Layout bg={'bg-fluid-bottom'}>
      <div className="container-documentos">
        <TitleSection
          title={'Documentos'}
          subtitle={
            FacturasEnabled
              ? 'Descargue aquí las boletas y facturas de sus contratos'
              : 'Descargue aquí las boletas de sus contratos'
          }
          all_medida_class={''}
          st_medida_class={''}
        />
        {contratos.length > 0 ? (
          contratos.map((item, index) => (
            <div
              className="container-documentos__box"
              key={item.contrato || index}
            >
              <h5
                onClick={(e) => {
                  toggle(e, index + 1);
                }}
              >
                Documentos Contrato N° {item.contrato}
                <i
                  className={
                    'float-right fas ' +
                    (collapse === index + 1
                      ? 'fa-chevron-up'
                      : 'fa-chevron-down')
                  }
                />
              </h5>
              <Collapse isOpen={collapse === index + 1}>
                <div className="container-documentos__detalle">
                  <DocumentosContrato
                    rut={getUser().rut}
                    contrato={item.contrato}
                  />
                </div>
              </Collapse>
            </div>
          ))
        ) : (
          <h2>No tiene contratos vigentes</h2>
        )}
      </div>
    </Layout>
  );
};

export default Documentos;
